import * as React from 'react';
import { BaSeParagraph, BaSeTheme } from '@base/react';

export const DeleteInfo = () => (
  <div style={{ padding: '4px 0' }}>
    <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
      Todos os eventos vinculados ao produto também serão excluídos.
    </BaSeParagraph>
    <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
      Tem certeza que deseja excluir?
    </BaSeParagraph>
  </div>
);

export const DeleteContent = ({ texts }) => (
  <div style={{ padding: '4px 0' }}>
    {texts?.map((text, index) => (
      <BaSeParagraph
        key={index}
        color={BaSeTheme.colors.institucionais.cinzaSebrae45}
      >
        {text}
      </BaSeParagraph>
    ))}
  </div>
);
